import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';
import { Server } from '@wajeez-web/core/api-base';

import { getFeedbackOptionsAsync, submitFeedbackAsync } from './slices';
import { GetFeedbackOptionsInput } from './types';

export const getFeedbackOptions = async (
  data: GetFeedbackOptionsInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getFeedbackOptionsAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const submitFeedback = async (
  data: Server.SubmitFeedbackInput,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(submitFeedbackAsync(data));

  return handleDispatchResult(res, onSuccess);
};
